import type { ChromeCopy } from './types'

export const gu: ChromeCopy = {
  appName: 'સમજો',
  tagline: 'કાગળ સમજો. આગળ શું કરવું તે જાણો.',
  savedTitle: 'સેવ કરેલા કાગળ',
  upcomingTitle: 'આવતી છેલ્લી તારીખો',
  markDone: 'કામ થઈ ગયું',
  doneLabel: 'થઈ ગયું',
  deadlineCheckIn: '{n} સેવ કરેલા કાગળની છેલ્લી તારીખ નજીક છે. કામ થઈ ગયું?',
  savedHint: 'આ ફક્ત આ જ ફોનમાં છે. કાગળનો ફોટો અને તેમાં લખેલું બધું ક્યારેય સેવ થતું નથી, ફક્ત જરૂરી માહિતી.',
  emptySaved: 'હજી કોઈ કાગળ સેવ કરેલો નથી.',
  clearAll: 'બધું કાઢી નાખો',
  deleteItem: 'કાઢી નાખો',
  aboutTitle: 'ગોપનીયતા અને જરૂરી માહિતી',
  privacyPoints: [
    'તમારા કાગળનો ફોટો અને તેમાં લખેલી વાતો આ જ ફોનમાં વંચાય છે અને સમજાવાય છે. ફોટો ક્યાંય અપલોડ થતો નથી.',
    'તમે "સેવ કરો" ન દબાવો ત્યાં સુધી કંઈ સેવ થતું નથી. "નવો કાગળ" દબાવતાં જ પહેલાંનો કાગળ સ્ક્રીન અને મેમરીમાંથી નીકળી જાય છે.',
    'સેવ કરો ત્યારે ફક્ત જરૂરી માહિતી (તારીખો, રકમ, નંબર) જ રાખવામાં આવે છે, અને તે પણ ફક્ત આ જ ફોનમાં — ફોટો કે લખેલું બધું નહીં. તમે તેને ગમે ત્યારે કાઢી નાખી શકો છો.',
    'ઇન્ટરનેટ ફક્ત ત્રણ કામ માટે વપરાય છે: પહેલી વાર વાંચવાનું ટૂલ અને અવાજો (સમજોની પોતાની સાઇટ પરથી) ડાઉનલોડ કરવા, અને — ફક્ત તમે કહો તો જ — કાગળની અંગ્રેજી લીટીઓનો અનુવાદ કરવા. અનુવાદ માટે મોકલેલી લીટીઓ સાચવવામાં આવતી નથી, અને આધાર અને ફોન જેવા નંબર પહેલાં જ કાઢી નાખવામાં આવે છે. ત્રીજું — ફક્ત તમે પ્રશ્ન પૂછો તો જ: જવાબ લખવા માટે કાગળનું લખાણ અને તમારો પ્રશ્ન સમજોના સર્વર અને એક AI સેવા (Groq) પર જાય છે, આધાર, પાન, ફોન અને ઈમેલ પહેલાં કાઢીને; ફક્ત સરકારી વેબસાઇટ જોવાય છે, અને કશું સાચવવામાં આવતું નથી. જે લીટીઓ અંગ્રેજીમાં નથી, તેનો અનુવાદ એક AI સેવા (Groq) કરે છે.',
    'સમજોમાં કોઈ જાહેરાત નથી. અમે ફક્ત એટલું ગણીએ છીએ કે કેટલા લોકો ઍપ ખોલે છે (Cloudflare Web Analytics, કૂકી વગર). તેમાં તમારા કાગળની કોઈ વાત હોતી નથી, અને કાગળમાં શું લખ્યું છે તે ક્યારેય લૉગ (નોંધ) કરવામાં આવતું નથી.'
  ],
  disclaimerTitle: 'આ સરકારી કે કાનૂની સલાહ નથી',
  disclaimer: 'સમજો એક સ્વતંત્ર મદદનું ટૂલ છે, સરકારી વેબસાઇટ નથી. તે તમારા કાગળને સહેલી ભાષામાં સમજાવે છે, પણ તેની સમજૂતી સત્તાવાર કે કાનૂની અર્થ નથી. જરૂરી વાતો હંમેશાં અસલ કાગળ કે તે આપનારી કચેરી સાથે મેળવી લો.',
  contactTitle: 'કોઈ તકલીફ છે?',
  contact: 'કોઈ પણ તકલીફ હોય, તો અમારો આ ઈમેલ પર સંપર્ક કરો:',
  freeTitle: 'બિલકુલ મફત',
  free: 'સમજો ઓપન-સોર્સ ટૂલથી ચાલે છે: વાંચવા માટે Tesseract, અને બોલવા માટે તમારા ફોનનો પોતાનો અવાજ અથવા Metaના ઓપન MMS અવાજો (CC BY-NC 4.0). કોઈ ખાતું નહીં, કોઈ પૈસા નહીં.',
  shareApp: 'WhatsApp પર શેર કરો',
  installApp: 'ઍપ ફોનમાં ઉમેરો',
  offline: 'તમે ઑફલાઇન છો',
  offlineHint: 'જો સમજો પહેલાં વાપર્યું હોય, તો ઇન્ટરનેટ વગર પણ કાગળ વાંચી શકાય છે.',
  shareAppMessage: 'સરકારી કાગળ સહેલી ભાષામાં સમજવા અને સાંભળવા માટે SAMJHO વાપરો (મફત):\nhttps://samjho.pages.dev'
}
